module.exports = __webpack_public_path__ + "static/jeffrey-24de431633a6446e76245040b66ee261.jpg";